<template>
	<div class="modal_info modal_show_mission_vision">
		<template v-if="loaded">
			<template v-if="company.target">
				<div class="header-submodal">
					<div class="title">{{ $t('company.mision_vision_title') }}</div>
				</div>

				<div class="description-modal">
					<div class="label">{{ $t('company.target') }}</div>
					<div class="value">{{ company.target }}</div>
				</div>
				<div class="description-modal">
					<div class="label">{{ $t('company.mission') }}</div>
					<div class="value" v-html="company.mission"></div>
				</div>
				<div class="description-modal" v-if="company.company_values">
					<div class="label">{{ $t('company.company_values') }}</div>
					<div class="value" v-html="company.company_values"></div>
				</div>
				<div class="description-modal" v-if="company.field_of_activity">
					<div class="label">{{ $t('company.field_of_activity') }}</div>
					<div class="value" v-html="company.field_of_activity"></div>
				</div>
				<div class="description-modal" v-if="company.successes">
					<div class="label">{{ $t('company.successes_results') }}</div>
					<div class="value" v-html="company.successes"></div>
				</div>
			</template>
			<template v-else>
				<div class="header-submodal">
					<div class="title">{{ $t('company.not_completed') }}</div>
				</div>
				<div class="description-modal" v-if="$auth.user().rights.admins_instance_crud">
					<div class="value">{{ $t('company.not_completed_help') }} <a @click="redirectPage">{{$t('settings-navbar.company')}}</a></div>
				</div>
				<div class="description-modal" v-else>
					<div class="value">{{ $t('company.only_for_admins') }}</div>
				</div>
			</template>

			<div class="button-actions">
				<button class="btn-tbf center blue" @click="closeModal">
					<div class="text">{{ $t('general.close') }}</div>
				</button>
			</div>
		</template>
		<loader-modal-mission-vision v-else />
	</div>
</template>

<script type="text/javascript">
	import IconClose from '../Icons/Close'
	import LoaderModalMissionVision from '../PagesLoaders/ModalMissionVision'

	export default {
		data() {
			return {
				loaded: false,
				company: {}
			};
		},
        components: {
        	IconClose,
        	LoaderModalMissionVision
        },
		mounted() {
			this.getCompanyData()
		},
		methods: {
			getCompanyData() {
				axios.get(`/brand/${this.$auth.user().master_instance_id}/show`)
				.then(({data}) => {
					this.company = data.data
				})
				.finally(() => {
					this.loaded = true
				})
			},
			closeModal(){
				this.$emit("close_modal");
			},
			redirectPage(){
				this.$router.push({name: 'settings-company'})
				this.$emit("close_modal");
			}
		}
	};
</script>